// extracted by mini-css-extract-plugin
export default {"details":"DonationDetailsModal_details__Dav7i"};